import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import FormStyles, { CommonLegendStyles } from '@stories/Components/Misc/Forms/Form.styles';
import CheckboxListStyles from '@stories/Components/Misc/Forms/Inputs/CheckboxList/CheckboxList.styles';
import RadioListStyles from '@stories/Components/Misc/Forms/Inputs/RadioList/RadioList.styles';
import TextboxStyles from '@stories/Components/Misc/Forms/Inputs/Textbox/Textbox.styles';
import styled from 'styled-components';
import SelectStyles from '../Forms/Inputs/Select/Select.styles';
import { ContentType } from '../SectionWrapper/SectionWrapper';
const Container = styled.form `
  --activeBgColour: ${brand.green.light};
  --activeBorderColour: ${brand.green.dark};
  --borderColour: ${brand.grey.light};

  &[data-type=${ContentType.Savings}] {
    --activeBgColour: ${brand.blue.light};
    --activeBorderColour: ${brand.blue.dark};
    --borderColour: ${brand.grey.light};

    ${CheckboxListStyles.Label},
    ${RadioListStyles.Label} {
      --activeColour: ${brand.blue.default};
    }
  }

  display: flex;
  flex-direction: column;
  gap: 24px;

  ${FormStyles.Label}[data-size='large'] {
    ${CommonLegendStyles};

    margin-bottom: 0px !important;
  }

  ${FormStyles.Title},
  ${FormStyles.Label}[data-size='large'] {
    border: 0;
  }

  ${FormStyles.Title} {
    margin-bottom: 8px;
  }

  ${CheckboxListStyles.Container},
  ${RadioListStyles.Container} {
    gap: ${fluid(8, 12)};
  }

  ${CheckboxListStyles.Label},
  ${RadioListStyles.Label} {
    ${transition('background-color, border-color, border-width', 0.2)};
    ${fonts.proximaNova.semiBold};

    --bgColour: ${brand.global.white};
    --borderOpacity: 0;

    position: relative;
    display: flex;
    align-items: center;
    font-size: ${fluid(14, 18)};
    padding: 4px ${fluid(12, 24)};
    height: ${fluid(44, 54)};
    border-radius: 10px;
    background: var(--bgColour);
    width: 100%;

    &::before,
    &::after {
      content: '';
      position: absolute;
      background: transparent !important;
      top: 0;
      left: 0;
      padding: 0;
      border-radius: inherit;
    }

    &::before {
      border: 1px solid var(--borderColour);
      width: 100%;
      height: 100%;
    }

    &::after {
      ${transition('opacity', 0.2)};

      border: 2px solid var(--activeBorderColour);
      opacity: var(--borderOpacity);
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      transform: none;
      -webkit-mask-image: none;
      mask-image: none;
    }
  }

  ${CheckboxListStyles.Label}::before {
    width: calc(100% - 2px);
    height: calc(100% - 2px);
  }

  ${CheckboxListStyles.Label}:hover,
  ${RadioListStyles.Label}:hover,
  ${CheckboxListStyles.Input}:checked + ${CheckboxListStyles.Label},
  ${RadioListStyles.Input}:checked + ${RadioListStyles.Label},
  ${CheckboxListStyles.Input}:focus-visible + ${CheckboxListStyles.Label},
  ${RadioListStyles.Input}:focus-visible + ${RadioListStyles.Label} {
    --borderOpacity: 1;
  }

  ${CheckboxListStyles.Input}:checked + ${CheckboxListStyles.Label},
  ${RadioListStyles.Input}:checked + ${RadioListStyles.Label} {
    --bgColour: var(--activeBgColour);
  }

  ${TextboxStyles.Prefix},
  ${TextboxStyles.Suffix} {
    background-color: ${brand.global.white};
    padding: 0 12px;
  }

  ${SelectStyles.Wrapper},
  ${TextboxStyles.InputWrapper} {
    max-width: 418px;
  }

  ${TextboxStyles.InputWrapper}:has(${TextboxStyles.Prefix}) ${TextboxStyles.Input} {
    border-left: 0;
    padding-left: 0;
  }

  ${TextboxStyles.InputWrapper}:has(${TextboxStyles.Suffix}) ${TextboxStyles.Input} {
    border-right: 0;
    padding-right: 0;
  }

  @container ${until(Device.TabletSmall)} {
    ${RadioListStyles.Container}:not(:has(${RadioListStyles.Option}:nth-child(3))) {
      flex-direction: row;

      ${RadioListStyles.Option} {
        flex: 1;
      }

      ${RadioListStyles.Label} {
        justify-content: center;
        text-align: center;
      }
    }

    ${CheckboxListStyles.Container}:not(:has(${CheckboxListStyles.Option}:nth-child(3))) {
      flex-direction: row;

      ${CheckboxListStyles.Option} {
        flex: 1;
      }

      ${CheckboxListStyles.Label} {
        justify-content: center;
        text-align: center;
      }
    }
  }
`;
const FiltersFormStyles = {
    Container,
};
export default FiltersFormStyles;
